import { Injectable } from '@angular/core';

import { RouterReducerState } from '@ngrx/router-store';
import { select, Store } from '@ngrx/store';

import { RouterStateUrl } from '@sd-portal/shared/util';

import { State } from '..';
import * as actions from './aircraft-profile.actions';
import * as aircraftProfileQuery from './aircraft-profile.selectors';

@Injectable()
export class AircraftProfileFacade {
  aircraftProfileId$ = this.store.pipe(select(aircraftProfileQuery.getAircraftProfileId));

  aircraftProfileSkeletonLoaded$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftProfileSkeletonLoaded)
  );
  aircraftProfileSkeletonLoading$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftProfileSkeletonLoading)
  );
  aircraftProfileAuditSkeleton$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftProfileAuditSkeleton)
  );

  aircraftRelationTypesLoaded$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftRelationTypesLoaded)
  );
  aircraftRelationTypesLoading$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftRelationTypesLoading)
  );
  aircraftRelationTypes$ = this.store.pipe(select(aircraftProfileQuery.getAircraftRelationTypes));

  postFlightVisibilityTypesLoaded$ = this.store.pipe(
    select(aircraftProfileQuery.getPostFlightVisibilityTypesLoaded)
  );
  postFlightVisibilityTypesLoading$ = this.store.pipe(
    select(aircraftProfileQuery.getPostFlightVisibilityTypesLoading)
  );
  postFlightVisibilityTypes$ = this.store.pipe(
    select(aircraftProfileQuery.getPostFlightVisibilityTypes)
  );

  colorSettingAuditsLoaded$ = this.store.pipe(
    select(aircraftProfileQuery.getColorSettingAuditLoaded)
  );
  colorSettingAuditsLoading$ = this.store.pipe(
    select(aircraftProfileQuery.getColorSettingAuditLoading)
  );
  colorSettingAudits$ = this.store.pipe(select(aircraftProfileQuery.getColorSettingAudits));

  aircraftProfileEngineAuditsLoaded$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftProfileEngineAuditLoaded)
  );
  aircraftProfileEngineAuditsLoading$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftProfileEngineAuditLoading)
  );
  aircraftProfileEngineAudits$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftProfileEngineAudits)
  );

  engineAuditsLoaded$ = this.store.pipe(select(aircraftProfileQuery.getEngineAuditLoaded));
  engineAuditsLoading$ = this.store.pipe(select(aircraftProfileQuery.getEngineAuditLoading));
  engineAudits$ = this.store.pipe(select(aircraftProfileQuery.getEngineAudits));

  aircraftProfileComponentAuditsLoaded$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftProfileComponentAuditLoaded)
  );
  aircraftProfileComponentAuditsLoading$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftProfileComponentAuditLoading)
  );
  aircraftProfileComponentAudits$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftProfileComponentAudits)
  );

  componentAuditsLoaded$ = this.store.pipe(select(aircraftProfileQuery.getComponentAuditLoaded));
  componentAuditsLoading$ = this.store.pipe(select(aircraftProfileQuery.getComponentAuditLoading));
  componentAudits$ = this.store.pipe(select(aircraftProfileQuery.getComponentAudits));

  aircraftPerformanceAuditsLoaded$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftPerformanceAuditLoaded)
  );
  aircraftPerformanceAuditsLoading$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftPerformanceAuditLoading)
  );
  aircraftPerformanceAudits$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftPerformanceAudits)
  );

  aircraftRelationAuditsLoaded$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftRelationAuditLoaded)
  );
  aircraftRelationAuditsLoading$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftRelationAuditLoading)
  );
  aircraftRelationAudits$ = this.store.pipe(select(aircraftProfileQuery.getAircraftRelationAudits));

  phoneNumberAuditsLoaded$ = this.store.pipe(
    select(aircraftProfileQuery.getPhoneNumberAuditLoaded)
  );
  phoneNumberAuditsLoading$ = this.store.pipe(
    select(aircraftProfileQuery.getPhoneNumberAuditLoading)
  );
  phoneNumberAudits$ = this.store.pipe(select(aircraftProfileQuery.getPhoneNumberAudits));

  faxNumberAuditsLoaded$ = this.store.pipe(select(aircraftProfileQuery.getFaxNumberAuditLoaded));
  faxNumberAuditsLoading$ = this.store.pipe(select(aircraftProfileQuery.getFaxNumberAuditLoading));
  faxNumberAudits$ = this.store.pipe(select(aircraftProfileQuery.getFaxNumberAudits));

  postFlightVisibilityAuditsLoaded$ = this.store.pipe(
    select(aircraftProfileQuery.getPostFlightVisibilityAuditLoaded)
  );
  postFlightVisibilityAuditsLoading$ = this.store.pipe(
    select(aircraftProfileQuery.getPostFlightVisibilityAuditLoading)
  );
  postFlightVisibilityAudits$ = this.store.pipe(
    select(aircraftProfileQuery.getPostFlightVisibilityAudits)
  );

  aircraftBillingRateAuditsLoaded$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftBillingRateAuditLoaded)
  );
  aircraftBillingRateAuditsLoading$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftBillingRateAuditLoading)
  );
  aircraftBillingRateAudits$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftBillingRateAudits)
  );

  aircraftProfileAuditsLoaded$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftProfileAuditLoaded)
  );
  aircraftProfileAuditsLoading$ = this.store.pipe(
    select(aircraftProfileQuery.getAircraftProfileAuditLoading)
  );
  aircraftProfileAudits$ = this.store.pipe(select(aircraftProfileQuery.getAircraftProfileAudits));

  addressAuditsLoaded$ = this.store.pipe(select(aircraftProfileQuery.getAddressAuditLoaded));
  addressAuditsLoading$ = this.store.pipe(select(aircraftProfileQuery.getAddressAuditLoading));
  addressAudits$ = this.store.pipe(select(aircraftProfileQuery.getAddressAudits));

  emailAddressAuditsLoaded$ = this.store.pipe(
    select(aircraftProfileQuery.getEmailAddressAuditLoaded)
  );
  emailAddressAuditsLoading$ = this.store.pipe(
    select(aircraftProfileQuery.getEmailAddressAuditLoading)
  );
  emailAddressAudits$ = this.store.pipe(select(aircraftProfileQuery.getEmailAddressAudits));

  constructor(
    private readonly store: Store<{
      router: RouterReducerState<RouterStateUrl>;
      sharedAudit: State;
    }>
  ) {}

  loadAircraftProfileAudit() {
    this.store.dispatch(actions.ResetAircraftProfile());
    this.store.dispatch(actions.LoadAircraftProfileAuditSkeleton());
    this.store.dispatch(actions.LoadAircraftRelationTypes());
    this.store.dispatch(actions.LoadAircraftRelationSubTypes());
    this.store.dispatch(actions.LoadPostFlightVisibilityTypes());
  }

  loadAircraftRelationAudits(aircraftRelationId: number) {
    this.store.dispatch(
      actions.LoadAircraftRelationAudit({
        aircraftRelationId,
        pageNumber: null,
        lastAuditLogId: null
      })
    );
  }

  loadColorSettingAudits(colorSettingId: number) {
    this.store.dispatch(
      actions.LoadColorSettingAudit({ colorSettingId, pageNumber: null, lastAuditLogId: null })
    );
  }

  loadProfileEngineAudits(aircraftProfileEngineId: number) {
    this.store.dispatch(
      actions.LoadAircraftProfileEngineAudit({
        aircraftProfileEngineId,
        pageNumber: null,
        lastAuditLogId: null
      })
    );
  }

  loadEngineAudits(engineId: number) {
    this.store.dispatch(
      actions.LoadEngineAudit({ engineId, pageNumber: null, lastAuditLogId: null })
    );
  }

  loadProfileComponentAudits(aircraftProfileComponentId: number) {
    this.store.dispatch(
      actions.LoadAircraftProfileComponentAudit({
        aircraftProfileComponentId,
        pageNumber: null,
        lastAuditLogId: null
      })
    );
  }

  loadComponentAudits(componentId: number) {
    this.store.dispatch(
      actions.LoadComponentAudit({ componentId, pageNumber: null, lastAuditLogId: null })
    );
  }

  loadAircraftPerformanceAudits(aircraftPerformanceId: number) {
    this.store.dispatch(
      actions.LoadAircraftPerformanceAudit({
        aircraftPerformanceId,
        pageNumber: null,
        lastAuditLogId: null
      })
    );
  }

  loadPhoneNumberAudits(phoneNumberId: number) {
    this.store.dispatch(
      actions.LoadPhoneNumberAudit({ phoneNumberId, pageNumber: null, lastAuditLogId: null })
    );
  }

  loadFaxNumberAudits(phoneNumberId: number) {
    this.store.dispatch(
      actions.LoadFaxNumberAudit({ phoneNumberId, pageNumber: null, lastAuditLogId: null })
    );
  }

  loadPostFlightVisibilityAudits(postFlightVisibilityId: number) {
    this.store.dispatch(
      actions.LoadPostFlightVisibilityAudit({
        postFlightVisibilityId,
        pageNumber: null,
        lastAuditLogId: null
      })
    );
  }

  loadAircraftBillingRateAudits(aircraftBillingRateId: number) {
    this.store.dispatch(
      actions.LoadAircraftBillingRateAudit({
        aircraftBillingRateId,
        pageNumber: null,
        lastAuditLogId: null
      })
    );
  }

  loadAircraftProfileAudits(aircraftProfileId: number) {
    this.store.dispatch(
      actions.LoadAircraftProfileAudit({
        aircraftProfileId,
        pageNumber: null,
        lastAuditLogId: null
      })
    );
  }

  loadAddressAudits(addressId: number) {
    this.store.dispatch(
      actions.LoadAddressAudit({ addressId, pageNumber: null, lastAuditLogId: null })
    );
  }

  loadEmailAddressAudits(emailAddressId: number) {
    this.store.dispatch(
      actions.LoadEmailAddressAudit({ emailAddressId, pageNumber: null, lastAuditLogId: null })
    );
  }

  nextAddressAuditPage(addressId: number) {
    this.store.dispatch(actions.LoadNextPageAddressAudit({ addressId }));
  }

  nextAircraftRelationAuditPage(aircraftRelationId: number) {
    this.store.dispatch(actions.LoadNextPageAircraftRelationAudit({ aircraftRelationId }));
  }

  nextColorSettingAuditPage(colorSettingId: number) {
    this.store.dispatch(actions.LoadNextPageColorSettingAudit({ colorSettingId }));
  }

  nextAircraftProfileEngineAuditPage(aircraftProfileEngineId: number) {
    this.store.dispatch(
      actions.LoadNextPageAircraftProfileEngineAudit({ aircraftProfileEngineId })
    );
  }

  nextEngineAuditPage(engineId: number) {
    this.store.dispatch(actions.LoadNextPageEngineAudit({ engineId }));
  }

  nextAircraftProfileComponentAuditPage(aircraftProfileComponentId: number) {
    this.store.dispatch(
      actions.LoadNextPageAircraftProfileComponentAudit({ aircraftProfileComponentId })
    );
  }

  nextComponentAuditPage(componentId: number) {
    this.store.dispatch(actions.LoadNextPageComponentAudit({ componentId }));
  }

  nextAircraftPerformanceAuditPage(aircraftPerformanceId: number) {
    this.store.dispatch(actions.LoadNextPageAircraftPerformanceAudit({ aircraftPerformanceId }));
  }

  nextPhoneNumberAuditPage(phoneNumberId: number) {
    this.store.dispatch(actions.LoadNextPagePhoneNumberAudit({ phoneNumberId }));
  }

  nextFaxNumberAuditPage(phoneNumberId: number) {
    this.store.dispatch(actions.LoadNextPageFaxNumberAudit({ phoneNumberId }));
  }

  nextEmailAddressAuditPage(emailAddressId: number) {
    this.store.dispatch(actions.LoadNextPageEmailAddressAudit({ emailAddressId }));
  }

  nextPostFlightVisibilityAuditPage(postFlightVisibilityId: number) {
    this.store.dispatch(actions.LoadNextPagePostFlightVisibilityAudit({ postFlightVisibilityId }));
  }

  nextAircraftBillingRateAuditPage(aircraftBillingRateId: number) {
    this.store.dispatch(actions.LoadNextPageAircraftBillingRateAudit({ aircraftBillingRateId }));
  }

  nextAircraftProfileAuditPage(aircraftProfileId: number) {
    this.store.dispatch(actions.LoadNextPageAircraftProfileAudit({ aircraftProfileId }));
  }
}
